import React, { useEffect } from 'react';

import CornerCloseButton from '../../../shared/CornerCloseButton/CornerCloseButton';
import AdminModalButton from '../../buttons/AdminModalButton/AdminModalButton';

import './ConfirmDeleteModal.css';

const ConfirmDeleteModal = ({
  onClose,
  onConfirm,
  deleteItemTitle,
  deleteItemMsg,
}) => {
  useEffect(() => {
    const handleKeyDown = (e) =>
      e.key === 'Escape' ? onClose() : e.key === 'Enter' ? onConfirm() : null;

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose, onConfirm]);

  return (
    <div className='confirm-delete-modal-shell-backdrop'>
      <div className='admin__delete'>
        <div className='modal-admin-delete-container'>
          <div className='modal-admin-close-btn-container'>
            <CornerCloseButton onClick={onClose} />
          </div>
          <div className='modal-admin-delete-title-container'>
            <h2 className='modal-admin-delete-title'>
              Are you sure you want to delete {deleteItemTitle}?
            </h2>
            {deleteItemMsg && <h3>{deleteItemMsg}</h3>}
          </div>
          <div className='modal-admin-delete-buttons-container'>
            <AdminModalButton
              type='button'
              onClick={onConfirm}
              style={{ width: '100px' }}
            >
              Delete
            </AdminModalButton>
            <AdminModalButton
              type='button'
              onClick={onClose}
              style={{ width: '100px' }}
            >
              Cancel
            </AdminModalButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
